import React, { Component, Fragment } from 'react'
import ErrorMessage from './error-message'
import Label, { SubLabel } from './label'
import cx from 'classnames'
import style from './textfield.scss'
import { textfieldPropTypes, makeIdString, wrapIfHorizontal } from './field'
import FieldSize, { fieldSizeDefaultProps } from './fieldsize'
import Icon from '../icon'

export default class Textfield extends Component {
  state = {
    value: this.props.value,
  }

  onChange = (event) => {
    this.setState({ value: event.target.value })

    if (this.props.onChange) {
      this.props.onChange(event)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value })
    }
  }

  getSuggestedLength() {
    return this.props.suggestedLength || this.props.maxLength
  }

  getCharacterCount() {
    return this.getSuggestedLength() - this.state.value.length
  }

  exceedsMaxLength() {
    return this.state.value.length > this.getSuggestedLength()
  }

  renderLabel = (id) => {
    return (
      <Fragment>
        <Label
          className={cx(this.props.classNames.label, {
            [style.errorLabel]: this.props.errorMessage,
          })}
          for={id}
          tooltip={this.props.tooltip}
          size={this.props.size}
        >
          {this.props.label}
        </Label>
        <SubLabel
          className={cx(this.props.classNames.subLabel, {
            [style.errorLabel]: this.props.errorMessage,
          })}
          size={this.props.size}
        >
          {this.props.subLabel}
        </SubLabel>
      </Fragment>
    )
  }

  renderField = (id) => {
    return (
      <Fragment>
        <div className={style.fieldIconContainer}>
          <input
            ref={this.props.innerRef}
            type={this.props.type}
            name={this.props.name}
            onChange={this.onChange}
            onBlur={this.props.onBlur}
            onFocus={this.props.onFocus}
            maxLength={this.props.maxLength}
            autoComplete={this.props.autoComplete}
            autoCorrect={this.props.autoCorrect}
            id={id}
            data-test-id={this.props.dataTestId}
            value={this.state.value}
            className={cx(
              { [style.field]: this.props.size === FieldSize.DEFAULT },
              { [style.fieldSmall]: this.props.size === FieldSize.SMALL },
              { [style.fieldInvalid]: this.props.errorMessage },
              this.props.classNames.field
            )}
            pattern={this.props.pattern}
            min={this.props.min}
            max={this.props.max}
            disabled={this.props.disabled}
            placeholder={this.props.placeholder}
            aria-label={this.props.ariaLabel}
            step={this.props.step}
            inputMode={this.props.inputMode}
          />
          {this.props.type === 'search' && (
            <Icon
              size="medium"
              type="search"
              className={cx(style.searchIcon, {
                [style.smallSearch]: this.props.size === FieldSize.SMALL,
              })}
            />
          )}
        </div>
        {this.props.showCharacterCount && (
          <div
            className={cx(
              style.characterCountWrapper,
              this.props.classNames.characterCountWrapper
            )}
          >
            <div
              className={cx(style.characterCount, {
                [style.error]: this.exceedsMaxLength(),
              })}
            >
              {this.getCharacterCount()}
            </div>
          </div>
        )}
        {this.props.errorMessage && (
          <ErrorMessage
            size={this.props.size}
            message={this.props.errorMessage}
            className={this.props.classNames.errorMessage}
          />
        )}
      </Fragment>
    )
  }

  render() {
    const id = this.props.id || makeIdString()
    const wrapperOpts = {
      isHorizontal: this.props.isHorizontal,
      classNames: this.props.classNames,
    }

    return (
      <div
        className={cx(style.Textfield, this.props.classNames.wrapper, {
          [style.TextfieldHorizontal]: this.props.isHorizontal,
        })}
      >
        {wrapIfHorizontal(
          { ...wrapperOpts, type: 'Label' },
          this.renderLabel(id)
        )}
        {wrapIfHorizontal(
          { ...wrapperOpts, type: 'Field' },
          this.renderField(id)
        )}
      </div>
    )
  }
}

Textfield.propTypes = {
  ...textfieldPropTypes,
}

Textfield.defaultProps = {
  type: 'text',
  value: '',
  classNames: {},
  inputMode: 'text',
  ...fieldSizeDefaultProps,
}
